"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicRouter = exports.privateRouter = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../schemas");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
const pathPrefix = '/folders';
const findOne = c.router({
    findOne: {
        method: 'GET',
        path: '/:id',
        pathParams: zod_1.z.object({
            id: schemas_1.Uuid,
        }),
        responses: {
            200: schemas_1.FolderDetail,
        },
        summary: 'Retrieve a folder by id, including listings of its subfolders, rundowns and scripts',
    },
});
const create = c.router({
    create: {
        method: 'POST',
        path: '',
        body: schemas_1.CreateFolderRequest,
        responses: {
            201: schemas_1.FolderSummary,
        },
    },
});
exports.privateRouter = c.router(Object.assign(Object.assign({}, findOne), create), {
    pathPrefix,
});
exports.publicRouter = c.router(Object.assign({}, findOne), {
    pathPrefix,
});
